import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3001"
});

export const reorderDrainagesProducts = createAsyncThunk(
    'drainages/reorder',
    async (productOrder, { dispatch, rejectWithValue }) => {
        try {
            const response = await api.put('/drainages/products/reorder', { productOrder });
            dispatch(fetchDrainagesProducts());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const createDrainagesProduct = createAsyncThunk(
    'drainages/createProduct',
    async (product, { rejectWithValue }) => {
        try {
            const response = await api.post('/drainages/products', product);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const updateDrainagesProduct = createAsyncThunk(
    'drainages/updateProduct',
    async (updateProduct, { rejectWithValue }) => {
        const { id, formData } = updateProduct;
        if (!id || !formData) {
            return rejectWithValue('Invalid product object: missing id or formData');
        }

        try {
            const response = await api.put(`/drainages/products/${id}`, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const fetchDrainagesProducts = createAsyncThunk(
    'drainages/fetchProducts',
    async () => {
        const response = await api.get('/drainages/products');
        const products = response.data.map(product => {
            const { _id, config, ...productWithoutConfig } = product;
            const configKeys = Object.keys(config);
            const newConfig = configKeys.map(key => ({
                key,
                ...config[key]
            }));
            return { ...productWithoutConfig, _id, config: newConfig };
        });

        // Сортування за полем "position"
        products.sort((a, b) => a.position - b.position);

        return products;
    }
);

export const fetchDrainagesProduct = createAsyncThunk(
    'drainages/fetchProduct',
    async (id) => {
        const response = await api.get(`/drainages/products/${id}`);
        const product = response.data;
        return product;
    }
);

export const deleteDrainagesProduct = createAsyncThunk(
    'drainages/deleteProduct',
    async (productId, { rejectWithValue }) => {
        try {
            const response = await api.delete(`/drainages/products/${productId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const fetchDrainagesFilters = createAsyncThunk(
    'drainages/fetchFilters',
    async () => {
        const response = await api.get('/drainages/filters');

        const updatedData = {};
        for (const [key, value] of Object.entries(response.data)) {
            const { _id, ...rest } = value;
            updatedData[key] = rest;
        }

        return updatedData;
    }
);

export const updateDrainagesFilters = createAsyncThunk(
    'drainages/updateFilters',
    async ({ field, variants }, { rejectWithValue }) => {
        try {
            const response = await api.put(`/drainages/filters/${field}/variants`, { variants });
            const { category, __v, _id, ...filteredData } = response.data;
            return filteredData;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
